module.exports = __webpack_public_path__ + "img/how-it-works-2.52333414.png";